import React, { useState, useEffect } from "react";
import { Button, Modal, Form, Input, Select, Row, Col, Typography, Table, message } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const { Title } = Typography;
const { Option } = Select;

function Clients() {
  const [open, setOpen] = useState(false);
  const [clients, setClients] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const accessToken = localStorage.getItem("access-token");

  // Fetch clients
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const res = await axios.get("https://rhrmapi.up2dateinc.com/api/clients", {
          headers: { Authorization: `Bearer ${accessToken}` }
        });
        setClients(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Failed to fetch clients:", err);
        setClients([]);
      }
    };

    fetchClients();
  }, [accessToken]);

  // Save new client
  const saveClient = async (values) => {
    try {
      const res = await axios.post(
        "https://rhrmapi.up2dateinc.com/api/clients",
        values,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      setClients([...clients, res.data]);
      message.success("Client added successfully");
      form.resetFields();
      setOpen(false);
    } catch (err) {
      console.error("Failed to add client:", err);
      message.error("Failed to add client");
    }
  };

  const columns = [
    { title: "SL No", render: (_, __, index) => index + 1 },
    { title: "Client Name", dataIndex: "name" },
    { title: "Company", dataIndex: "company" },
    { title: "Email Address", dataIndex: "email" },
    { title: "Country", dataIndex: "country" },
  ];

  return (
    <div>
      <Row justify="space-between" align="middle">
        <Title level={3}>Clients</Title>

        <div>
          <Button type="primary" style={{ marginRight: 10 }} onClick={() => setOpen(true)}>
            Add New Client
          </Button>

          <Button onClick={() => navigate("/admin/manage-clients")}>
            Manage Client
          </Button>
        </div>
      </Row>

      <Table
        rowKey="_id"
        columns={columns}
        dataSource={Array.isArray(clients) ? clients : []}
        pagination={{ pageSize: 5 }}
        style={{ marginTop: 20 }}
      />

      <Modal
        title="Client Form"
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={600}
      >
        <Form layout="vertical" form={form} onFinish={saveClient}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="name" label="Client Name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="country" label="Country">
                <Select>
                  <Option value="India">India</Option>
                  <Option value="United States">United States</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="email" label="Email Address">
                <Input />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="company" label="Company">
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item name="address" label="Address">
                <Input.TextArea rows={3} />
              </Form.Item>
            </Col>
          </Row>

          <Button type="primary" htmlType="submit" block>
            Save Client
          </Button>
        </Form>
      </Modal>
    </div>
  );
}

export default Clients;